import React from 'react'
import { Link } from 'react-router-dom'

const Tools = () => {
    return (
        <>
            <div className="container">
                <div className="row">
                    <div className="col-md-6">
                        <div className="col-sm mx-auto mt-3">
                            <Link
                                className="mx-auto mt-3 exercise_box"
                                to={"/TypingMaster"}
                                style={{ textDecoration: "none" }}
                            >
                                <h3 className="exercise-heading">Typing Master</h3>
                            </Link>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="col-sm mx-auto mt-3">
                            <Link
                                className="mx-auto mt-3 exercise_box"
                                to={"/WhiteBoard"}
                                style={{ textDecoration: "none" }}
                            >
                                <h3 className="exercise-heading">WhiteBoard</h3>
                            </Link>
                        </div>
                    </div>

                    <div className="col-md-6">
                        <div className="col-sm mx-auto mt-3">
                            <Link
                                className="mx-auto mt-3 exercise_box"
                                to={"/DynamicDocx"}
                                style={{ textDecoration: "none" }}
                            >
                                <h3 className="exercise-heading">Ms Word</h3>
                            </Link>
                        </div>
                    </div>

                </div>
            </div>
        </>
    )
}

export default Tools